// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".radiobutton_group{padding-top:10px!important}#firma_wrapper.sinbanner{display:flex;justify-content:center}#firma_wrapper.conbanner{display:flex;justify-content:left}@media (max-width:1800px){#rdFirmas #radio3,#rdFirmas #radio4{width:67px}}@media (max-width:1600px){#rdFirmas #radio3,#rdFirmas #radio4{width:57px}}.previewfirma{padding:0}.previewfirma>.info_text{margin:0 auto 20px;max-width:80%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
